<template>
  <div>
    <AccountLink :sign-in-mobile-nudge-experience="signInMobileNudgeExperience" />
    <AccountLink
      link-text="My Account - Sign in or Register"
      is-mobile-only
      mounting-point-selector="[data-js='mobile-nav-login-link']"
    />
  </div>
</template>

<script>
import { AccountLink } from '@rei/account-flyout';

export default {
  name: 'AccountLinkFragment',
  components: {
    AccountLink,
  },
  props: {
    signInMobileNudgeExperience: {
      type: String,
      default: 'control',
    },
  },
};
</script>
